import styled from 'styled-components';

export const UserContainer = styled.div`
  width: 600px;
  border-radius: 150px;
  display: flex;
  box-shadow: 0 0 40px -20px rgba(0, 0, 0, 0.35);
  gap: 32px;
  padding: 8px;
  margin: 16px auto;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    width: 100%;
    flex-wrap: wrap;
    border-radius: 24px;
    justify-content: center;
    gap: 16px;
    padding: 16px;
  }
`;

export const UserContent = styled.div`
  width: 100%;
  font-size: 22px;
  font-weight: bold;
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  flex-direction: column;
  p {
    margin: 0;
  }
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 16px;
  }
`;

export const UserImageContainer = styled.div`
  min-width: 200px;
  max-width: 200px;
  height: 200px;
  flex: 1;
  overflow: hidden;
  border-radius: 50%;
`;

export const IGIcon = styled.img`
  width: 40px;
  text-align: center;
`;
